@if (ads && !isClosed) {
  <div class="d-flex justify-content-center adds-mobile-layer">
    <a (click)="close()" class="adds-mobile-layer-close app-cursor">{{ 'web.close' | translate | transinit }}</a>
    @for (add of this.ads; track trackById($index, add)) {
      <div
        [id]="add.pageElementId"
        style="width: {{ add.width ?? 'auto' }};height: {{ add.height ?? 'auto' }}"
      ></div>
    }
  </div>
}
